/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedHeadLinkTags_metadata$ref = any;
type SharedHeadMetaTags_metadata$ref = any;
type SharedHeadScriptTags_metadata$ref = any;
type SharedHeadTitleTag_metadata$ref = any;
export type BuySharedHead_buyPage$ref = any;
export type BuySharedHead_buyPage = {
    readonly metadata: {
        readonly canonical: string | null;
        readonly disableIndexing: boolean | null;
        readonly prev: string | null;
        readonly " $fragmentRefs": SharedHeadTitleTag_metadata$ref & SharedHeadMetaTags_metadata$ref & SharedHeadScriptTags_metadata$ref & SharedHeadLinkTags_metadata$ref;
    } | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly photos: ReadonlyArray<{
                readonly versions: ReadonlyArray<{
                    readonly webPath: string | null;
                } | null> | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": BuySharedHead_buyPage$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedHead_buyPage",
    "type": "BuyPageConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "metadata",
            "storageKey": null,
            "args": null,
            "concreteType": "MetaData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canonical",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "disableIndexing",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prev",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SharedHeadTitleTag_metadata",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SharedHeadMetaTags_metadata",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SharedHeadScriptTags_metadata",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SharedHeadLinkTags_metadata",
                    "args": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "BuyPageEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": "photos(limit:1)",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "limit",
                                    "value": 1
                                }
                            ],
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "versions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ItemPhotoVersion",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "webPath",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'e17bbb8c6b13d6e9622306a8fab7f42d';
export default node;
